import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CardItem from "../CardItem";
import styles from "./CardList.module.css";

const CardList = ({ cardList, onSelectCard }) => {
  const [selectedCard, setSelectedCard] = useState(null);

  useEffect(() => {
    const initiallySelectedCard = cardList.find((card) => card.isSelected);
    if (initiallySelectedCard) {
      setSelectedCard(initiallySelectedCard);
    }
  }, [cardList]);

  const handleCardSelect = (selectedCardInfo) => {
    let updatedCardList;
    if (selectedCardInfo === selectedCard) {
      updatedCardList = cardList.map((card) => ({
        ...card,
        isSelected: false,
        isChecked: false,
      }));
      setSelectedCard(null);
    } else {
      updatedCardList = cardList.map((card) =>
        card === selectedCardInfo
          ? { ...card, isSelected: true, isChecked: true }
          : { ...card, isSelected: false, isChecked: false }
      );
      setSelectedCard(selectedCardInfo);
    }
    onSelectCard(updatedCardList);
  };

  return (
    <div>
      {cardList.map((cardInfo) => (
        <div
          key={cardInfo.id || cardInfo.cardId || cardInfo.lastFour}
          className={
            selectedCard === cardInfo ? styles.checked : styles.selected
          } // Change the conditional class here
        >
          <CardItem
            key={cardInfo.id || cardInfo.cardId || cardInfo.lastFour}
            cardInfo={cardInfo}
            onSelect={() => handleCardSelect(cardInfo)}
            isSelected={cardInfo === selectedCard} // Pass isSelected based on selectedCard
          />
        </div>
      ))}
    </div>
  );
};

CardList.propTypes = {
  cardList: PropTypes.arrayOf(
    PropTypes.shape({
      zipCode: PropTypes.string.isRequired,
      nickName: PropTypes.string.isRequired,
      lastFour: PropTypes.string.isRequired,
      expYear: PropTypes.string.isRequired,
      expMonth: PropTypes.string.isRequired,
      isSelected: PropTypes.bool.isRequired,
      isChecked: PropTypes.bool.isRequired,
    })
  ).isRequired,
  onSelectCard: PropTypes.func.isRequired,
};

export default CardList;
